module.exports = __webpack_public_path__ + "img/Facebook-logo-mobile.9c220f3f.png";